<ng-container
  *ngIf="{
    ticketsNext: ticketsNext$ | async,
    nextTicketListCurrentPage: nextTicketListCurrentPage$ | async,
    ticketsPrevious: ticketsPrevious$ | async,
    previousTicketListCurrentPage: previousTicketListCurrentPage$ | async,
  } as vm"
>
  <ion-header class="ion-no-border">
    <ion-toolbar>
      <ion-title>Mis boletos</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="buyTicketByQr()">
          <ion-icon slot="end" name="qr-code"></ion-icon>
          <ion-label>Compra</ion-label>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-toolbar>
      <ion-segment mode="md" [(ngModel)]="show">
        <ion-segment-button value="next">
          <ion-label>PRÓXIMOS</ion-label>
        </ion-segment-button>
        <ion-segment-button value="old">
          <ion-label>PASADOS</ion-label>
        </ion-segment-button>
      </ion-segment>
    </ion-toolbar>
  </ion-header>

  <ion-content class="ion-padding">
    <ion-refresher (ionRefresh)="doRefresh($event)" slot="fixed">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <div class="ticketsNew" *ngIf="show === 'next'">
      <app-tickets-list-skeleton
        *ngIf="vm.nextTicketListCurrentPage === 1 && loadingTickets"
      ></app-tickets-list-skeleton>
      <ion-button
        expand="block"
        [routerLink]="['/tecservice-transportec/transportec/tickets']"
        *ngIf="(!vm.ticketsNext?.data?.length) && !loadingTickets"
      >
        Nuevo boleto
      </ion-button>
      <div
        class="ticket new"
        (click)="ticket.status !== -1 && goTicket(ticket)"
        *ngFor="let ticket of vm.ticketsNext?.data"
        [class.cancelled]="ticket.status === -1"
      >
        <ion-row>
          <ion-col size="9" class="body">
            <ion-item lines="full">
              <ion-img class="photo" [src]="ticket.route_icon" slot="start" *ngIf="ticket.route_icon"></ion-img>
              <ion-label>
                <h3>{{ticket.route_name}}</h3>
                <p>Fecha: {{ticket.date | toDatestring:'date'}}</p>
              </ion-label>
            </ion-item>
            <ion-row>
              <ion-col>
                <h3>{{ticket.starts_at | toDatestring:'H:mm'}}</h3>
                <p *ngIf="ticket.type==='go'">{{ticket.stop_name}}</p>
                <p *ngIf="ticket.type==='return'">{{ticket.stop_name}}</p>
              </ion-col>
              <ion-col size="2">
                <h3>&nbsp;</h3>
                <ion-icon name="arrow-forward" color="primary"></ion-icon>
              </ion-col>
              <ion-col>
                <h3>&nbsp;</h3>
                <p *ngIf="ticket.type==='go'">{{ticket.stop2_name}}</p>
                <p *ngIf="ticket.type==='return'">{{ticket.stop2_name}}</p>
              </ion-col>
              <div class="tracking" *ngIf="ticket.realtrip_active && ticket.buses_gps?.length">
                <ion-button (click)="onTrack(ticket, $event)" shape="round" size="small">
                  <ion-icon slot="icon-only" src="/assets/icon/map-location.svg"></ion-icon>
                </ion-button>
                <p>Track</p>
              </div>
            </ion-row>
          </ion-col>
          <ion-col size="3" class="coupon">
            <div class="centered-vertically">
              <h3>ID: {{ticket.id}}</h3>
              <h1 *ngIf="ticket.amount && ticket.amount > 0">
                {{ticket.amount | currency : 'USD' : 'symbol' : '1.0-0' }}
              </h1>
              <ion-button shape="round" size="small" type="submit" expand="block" *ngIf="ticket.status !== -1">
                Ver
              </ion-button>
              <p class="canceled-label" *ngIf="ticket.status === -1">CANCELADO</p>
            </div>
          </ion-col>
        </ion-row>
      </div>
    </div>
    <div class="tickets" *ngIf="show==='old'">
      <app-tickets-list-skeleton
        *ngIf="vm.previousTicketListCurrentPage === 1 && loadingTickets"
      ></app-tickets-list-skeleton>
      <div class="ticket old" *ngFor="let ticket of vm.ticketsPrevious?.data" [class.cancelled]="ticket.status === -1">
        <ion-row>
          <ion-col size="9" class="body">
            <ion-item lines="full">
              <ion-img class="photo" [src]="ticket.route_icon" slot="start" *ngIf="ticket.route_icon"></ion-img>
              <ion-label>
                <h3>{{ticket.route_name}}</h3>
                <p>Fecha: {{ticket.date | toDatestring:'date'}}</p>
              </ion-label>
            </ion-item>
            <ion-row>
              <ion-col>
                <h3>{{ticket.starts_at | toDatestring:'H:mm'}}</h3>
                <p *ngIf="ticket.type==='go'">{{ticket.stop_name}}</p>
                <p *ngIf="ticket.type==='return'">{{ticket.stop_name}}</p>
              </ion-col>
              <ion-col size="2">
                <h3>&nbsp;</h3>
                <ion-icon name="arrow-forward" color="primary"></ion-icon>
              </ion-col>
              <ion-col>
                <h3>&nbsp;</h3>
                <p *ngIf="ticket.type==='go'">{{ticket.stop2_name}}</p>
                <p *ngIf="ticket.type==='return'">{{ticket.stop2_name}}</p>
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col size="3" class="coupon">
            <div *ngIf="ticket.status >= 0">
              <div class="fab-container" *ngIf="!ticket.review && ticket.status > 0 && ticket.id">
                <ion-fab-button color="primary" size="small" (click)="review(ticket.id)">
                  <ion-icon src="/assets/icon/calificar-app.svg"></ion-icon>
                </ion-fab-button>
                <ion-label>Calificar</ion-label>
              </div>
              <div class="fab-container" *ngIf="ticket.review && ticket.review.answer1">
                <ion-fab-button color="primary" size="small">
                  <p>{{ticket.review.answer1}}/5</p>
                </ion-fab-button>
              </div>
              <div class="fab-container2" *ngIf="ticket.id">
                <ion-fab-button color="primary" size="small" (click)="goHelpList(ticket.id)">
                  <ion-icon src="/assets/icon/help.svg"></ion-icon>
                </ion-fab-button>
                <ion-label>Ayuda</ion-label>
              </div>
            </div>
            <p class="canceled-label" *ngIf="ticket.status === -1">
              <br />
              <br />
              <br />
              <br />
              <br />
              CANCELADO
            </p>
          </ion-col>
        </ion-row>
      </div>
    </div>
    <ion-infinite-scroll *ngIf="show==='next'" (ionInfinite)="doInfinite($event, vm.ticketsNext!)">
      <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Cargando..."></ion-infinite-scroll-content>
    </ion-infinite-scroll>
    <ion-infinite-scroll *ngIf="show==='old'" (ionInfinite)="doInfinite($event, vm.ticketsPrevious!)">
      <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Cargando..."></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-content>

  <ion-footer>
    <ion-toolbar>
      <ion-button
        expand="block"
        [routerLink]="['/tecservice-transportec/transportec/tickets']"
        *ngIf="(vm.ticketsNext?.data?.length)"
      >
        Nuevo boleto
      </ion-button>
    </ion-toolbar>
  </ion-footer>
</ng-container>
